import { InjectionToken } from '@angular/core';

export const OFFICE_HOST_TYPE = new InjectionToken<Office.HostType | null>('OFFICE_HOST_TYPE');
export const WIDGET_HOST_TYPE = new InjectionToken<boolean>('WIDGET_HOST_TYPE');
